export default __webpack_public_path__ + "static/ios15-safe-area-inset-bottom-8ba8d7d7139464cf2bb8f378b061788e.mp4";